import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
// First-party proxy (nginx /fx-events/ -> us.i.posthog.com) so Brave Shields / ad blockers
// don't drop the request. See infra/nginx/sites-enabled/foxet.
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://app.foxet.ai/fx-events';

let initialized = false;

/**
 * PostHog (including session replay) must only run for the authenticated
 * dashboard — never on public, customer-facing surfaces (/w, /d, /book,
 * /meeting, tenant custom domains) where a prospect, not a Foxet user, is
 * looking at the screen.
 *
 * This is deliberately NOT called at app boot. It is called only from
 * places that are structurally authenticated: `ProtectedRoute` (App.tsx,
 * gates every dashboard route) and `setAuth` (store.ts, only reached after
 * a successful login). Any public route, present or future, never reaches
 * either call site, so it never initializes PostHog — the default is off,
 * and adding a new public route can't accidentally turn it on. Idempotent:
 * safe to call repeatedly (e.g. every ProtectedRoute mount).
 */
export function initPosthog() {
  if (initialized || !POSTHOG_KEY) return;
  initialized = true;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    ui_host: 'https://us.posthog.com',
    autocapture: false, // dashboard has complex UI, autocapture is noisy
    capture_pageview: false,
    capture_pageleave: true,
    persistence: 'localStorage+cookie',
    session_recording: {
      recordCrossOriginIframes: false,
    },
  });
}

export { posthog };
